const menuNorwegian = {
  customerSwitcher: {
    workingAs: "Jobber som:",
    yourself: "Deg selv",
    onBehalfBanner: "Du jobber på vegne av {customerName}"
  },
  menuItems: {
    dashboard: "Dashboard",
    linkedInPosts: "LinkedIn Innlegg",
    aiGenerator: "AI Generator",
    caseGenerator: "Case Generator",
    myPosts: "Mine Innlegg",
    imageArchive: "Bildearkiv",
    scheduler: "Planlegger",
    aiSettings: "AI Innstillinger",
    settings: "Innstillinger",
    organization: "Organisasjon"
  },
  theme: {
    lightTheme: "Lyst tema",
    darkTheme: "Mørkt tema"
  },
  userMenu: {
    billing: "Fakturering",
    logout: "Logg ut"
  }
};

export default menuNorwegian; 